import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import i18n from "../lang/i18n";
import labels from "../data/labels";
import mailClasses from "../data/mail-classes";
import print from "print-js";
import ws from "./ws";
import plugin from "./plugin";

Vue.use(Vuex);

function arrMove(arr, oldIndex, newIndex) {
  if (newIndex >= arr.length) {
    let i = newIndex - arr.length + 1;
    while (i--) {
      arr.push(undefined);
    }
  }
  arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
  return arr;
}

// root state object. each Vuex instance is just a single state tree.
const state = {
  isShipper: null,
  user: {},
  user_balance: 0.0,
  user_notifications: [],
  shipsurance: 0.0,

  ecommerceCount: 0,
  importCount: 0,

  shipping_services: [],
  carrier_rules: {},
  package_types: [
    {
      name: "Package (your box/polybag)",
      value: "PKG",
    },
    {
      name: "Irregular Package",
      value: "IRRPKG",
    },
    {
      name: "Flat Rate Envelope",
      value: "FRE",
    },
    {
      name: "Small Flat Rate Box",
      value: "SFRB",
    },
    {
      name: "Medium Flat Rate Box 2",
      value: "FRB",
    },
    {
      name: "Large Flat Rate Box",
      value: "LFRB",
    },
    {
      name: "Flat Rate Padded Envelope",
      value: "PFRENV",
    },
    {
      name: "Flat Rate Legal Envelope",
      value: "LGLFRENV",
    },
    {
      name: 'Military Large Flat Rate Box',
      value: "MLFRB",
    },
    {
      name: 'Soft Pack Envelope',
      value: 'SOFTPACK'
    },
    // {'name' : 'Letter', 'value':'LETTER'}, {'name' : 'Large Envelope',
    // 'value':'LGENV'},
    // {'name' : 'DVD Flat Rate Box', 'value':'DVDBOX'},
    // {'name' : 'Large Video Flat Rate Box', 'value':'VIDEOBOX'},
    // {
    //   name: "Regional Box A",
    //   value: "RBA",
    // },
    // {
    //   name: "Regional Box B",
    //   value: "RBB",
    // },
  ],

  printer: {
    printers: [],
    default: null,
  },

  customs_name: "",
  employee_name: "",

  recipients: [],
  products: [],
};

// mutations are operations that actually mutates the state. each mutation
// handler gets the entire state tree as the first argument, followed by
// additional payload arguments. mutations must be synchronous and can be
// recorded by plugins for debugging purposes.
//TODO: why is my websocket throws an error when no subscriber
const mutations = {
  setUser(state, user) {
    state.user = user;
    qz
      .configs
      .setDefaults({
        orientation: null,
        margins: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
        },
      });
  },
  setIsShipper(state, val) {
    state.isShipper = val;
  },
  setUserBalance(state, balance) {
    state.user_balance = balance;
  },
  setShipsurance(state, shipsurance) {
    state.shipsurance = shipsurance;
  },
  setShippingServices(state, shipping_services) {
    state.shipping_services = shipping_services;
  },
  setCarrierRules(state, rules) {
    state.carrier_rules = rules;
  },

  setDefaultPrinter(state, printer) {
    state.printer.default = printer;
  },

  setCustomsName(state, name) {
    state.customs_name = name;
  },

  setNotification(state, notif) {
    state.user_notifications = notif;
  },

  setEmployeeName(state, name) {
    state.employee_name = name;
  },

  setEcommerceCount(state, val) {
    state.ecommerceCount = val;
  },

  setImportCount(state, val) {
    state.importCount = val;
  },
};
// actions are functions that cause side effects and can involve asynchronous
// operations.
const actions = {
  refreshUser: ({ commit, state }) => {
    return new Promise((resolve, reject) => {
      axios
        .get("/users?ajax=true")
        .then(({ data }) => {
          commit("setUser", data);
          resolve();
        })
        .catch((e) => {
          reject();
        });
    });
  },
  refreshUserBalance(context) {
    axios
      .get("/user/balance?ajax=true")
      .then((response) => {
        context.commit("setUserBalance", response.data.balance);
      })
      .catch(function () { });
  },

  refreshShipsurance(context) {
    axios
      .get("/user/shipsurance")
      .then((response) => {
        context.commit("setShipsurance", response.data);
      })
      .catch(function () { });
  },

  refreshCarrierRules(context) {
    axios
      .get("/shipping_services/rules?ajax=true")
      .then((response) => {
        context.commit("setCarrierRules", response.data);
      })
      .catch(function () { });
  },

  refreshShippingServices(context) {
    axios
      .get("/shipping_services?ajax=true")
      .then((response) => {
        context.commit("setShippingServices", response.data);
      })
      .catch(function () {
        console.log("error");
      });
  },

  refreshNotification(context) {
    axios
      .get("/user/notification")
      .then((response) => {
        context.commit("setNotification", response.data);
      })
      .catch(function () { });
  },

  async refreshRecipients({ state }) {
    try {
      const { data } = await axios.get("/addresses/all");
      state.recipients = _.keyBy(data, "id");
    } catch (e) { }
  },

  async refreshProducts({ state }) {
    try {
      const { data } = await axios.get("/products/all");
      state.products = _.keyBy(data, "id");
    } catch (e) { }
  },

  refreshEcommerceCount(context) {
    axios
      .get("/orders-ecommerce-count")
      .then((response) => {
        context.commit("setEcommerceCount", response.data);
      })
      .catch(function () { });
  },

  refreshImportCount(context) {
    // console.log("REFRESH IMPORT");
    axios
      .get("/orders-import-count")
      .then((response) => {
        context.commit("setImportCount", response.data);
      })
      .catch(function () { });
  },

  // printer methods
  setDefaultPrinter(context, printer) {
    context.commit("setDefaultPrinter", printer);
  },
  setOrientation(context, orientation) { },

  addPrintJob(context, job) {
    console.log("Store Printing", job);

    if (job.label && job.type !== "pdf" && job.type !== "return" && job.type !== "rlabel") {
      let printData = [
        {
          type: "pdf",
          format: "base64",
          data: job.label,
        },
      ];

      const printerName = context.getters.getDefaultPrinter;
      const printerOptions = {
        scaleContent: false,
        margins: context.getters.getLabelMargins,
        size: context.getters.getLabelSize,
        units: "in",
        colorType: "grayscale",
        interpolation: "nearest-neighbor",
        rasterize: "false",
        orientation: context.getters.getLabelOrientation,
      };
      // console.log("Printer Name:", printerName);
      // console.log("Printer Data:", printData);
      // console.log("Printer Options:", printerOptions);

      const printerConfig = qz.configs.create(printerName, printerOptions);
      //config.setPrinter({name: printerName});

      try {
        if (printerName === null) throw new Error("No Printer selected");
        qz.print(printerConfig, printData)
          .catch((err) => {
            console.log("qz printing error, using browser default");
            print({ printable: job.label, type: "pdf", base64: true });
          });
      } catch (e) {
        console.warn(
          "No QZ tray installed or no printer was selected, using browser default.",
        );
        // console.log(job.type);
        if (job.type === "both-return" || job.type === "rlabel-both" && job.label_url) {
          window.open(job.label_url);
        } else {
          print({ printable: job.label, type: "pdf", base64: true });
        }
      }
    } else if (job.label_url) {
      window.open(job.label_url);
    } else {
      this._vm.$toastr.e("Failed to print label");
      console.log("Invalid job", job);
    }
  },
};

// getters are functions
const getters = {
  getUser(state, getters) {
    return state.user;
  },
  getIsShipper(state) {
    if (state.isShipper) {
      return true;
    }
    return localStorage.getItem("shipper");
  },
  loggedIn(state, getters) {
    return !_.isEmpty(state.user);
  },

  getNotification(state, getters) {
    return state.user_notifications;
  },

  getUserBalance(state, getters) {
    return state.user_balance;
  },
  getShipsurance(state, getters) {
    return state.shipsurance;
  },
  getUserOrigins(state, getters) {
    return state.user.origins;
  },

  getShippingServices(state, getters) {
    return state.shipping_services;
  },

  getShippingService: (state, getters) =>
    (serviceId) => {
      return _.find(state.shipping_services, (service) => {
        return service.code === serviceId;
      });
    },

  getCarrierRules: (state, getters) =>
    (country = "US") => {
      if (country !== "US") country = "CA"
      if (country in state.carrier_rules) {
        let service_classes = state.carrier_rules[country];
        if (country === "US") {
          service_classes = _.pickBy(service_classes, (v, k) => {
            return !["EMI", "FCPIS", "PMI"].includes(k);
          });
        }
        else {
          service_classes = _.pickBy(service_classes, (v, k) => {
            return !["UGA", "MEDIA", "EM", "PM"].includes(k);
          });
        }
        return service_classes;
      } else {
        return [];
      }
      // return country in state.carrier_rules
      //   ? state.carrier_rules[country]
      //   : [];
    },
  getServiceCarrierRules: (state, getters) =>
    (serviceId, country = "US") => {
      try {
        if (country !== "US") country = "CA"
        const carrierRules = country in state.carrier_rules
          ? state.carrier_rules[country][serviceId] || []
          : [];
        return carrierRules 
      } catch (e) {
        console.error("e");
      }
    },
  getServicePackageRules: (state, getters) =>
    (serviceId, country = "US", filterInactive = false) => {
      try {
        if (country !== "US") country = "CA"
        if (!(country in state.carrier_rules)) {
          return [];
        }
        let rules = Object
          .keys(state.carrier_rules[country])
          .includes(serviceId)
          ? state.carrier_rules[country][serviceId].parcelTypeRules
          : [];

        // Filter package options
        rules = _.filter(rules, (rule) => {
          const parcelType = rule.parcelType.toUpperCase();
          const typeId = rule.rateTypeId.toUpperCase();
          const removeParcelType = [
            "PC", // POST CARD
            "LP", // Large Package
            "DVDBOX", // DVD Box
            "VIDEOBOX", // Video Box
            "LTR", // LETTER
            "LTR-IMB", // LETTER
            "LETTER", // LETTER
            "LGENV", // Large Evelope
            "LGENV-IMB", // Large Evelope
            "FLAT", // Large Envelope (Flat)
            // "IRRPKG", // Irregular Package, Artist client ask for it
            "NMLETTER", // Non-Machinable Letter
            "NMLTR", // Non-Machinable Letter
            "RBA", // REGIONAL BOX A
            "RBB", // REGIONAL BOX B
          ];
          // use below to allow packages types base on service class
          switch (serviceId) {
            // International
            // case "EMI":
            // case "FCPIS":
            // case "PMI":
            //   return !removeParcelType.includes(parcelType) &&
            //     typeId === "CONTRACT_RATES";
            //   break;
            case "UGA":
            case "PM":
              // AFTER HOLIDY SEASON
              return !removeParcelType.includes(parcelType) &&
                typeId === "CONTRACT_RATES";
              // DURING HOLIDAY SEASON
              // With Duplicates so chose COMMERCIAL_BASE vs RETAIL
              // return !removeParcelType.includes(parcelType) &&
              //   typeId === "COMMERCIAL_BASE";
            // break;
            // case "PRCLSEL":
            //   break;
            // case "MEDIA":
            //   break;
            // case "EM":
            // break;
            default: // NO DUPLICATES PRCLSEL, MEDIA, EM
              return !removeParcelType.includes(parcelType);
          }
        });

        if (filterInactive) {
          if (_.isArray(state.user.active_mail_classes)) {
            rules = _.filter(rules, (rule) => {
              return state.user.active_mail_classes.includes(
                `${serviceId}-${rule.parcelType}`,
              );
            });
          } else {
            // filter default inactive
            rules = _.filter(rules, (rule) => {
              return !mailClasses.disabled.default.includes(
                `${serviceId}-${rule.parcelType}`,
              );
            });
          }
        }

        rules = _.map(rules, (rule) => {
          if (i18n.te(`shipping_rules.package.${rule.parcelType}`)) {
            rule.brandedName = i18n.t(
              `shipping_rules.package.${rule.parcelType}`,
            );
          }
          return rule;
        });

        // Move Package parcel type on the first index
        // const fIndex =  _.findIndex(rules, {parcelType: 'PKG'});
        // if (fIndex > -1) {
        //   rules = arrMove(rules, fIndex, 0)
        // }

        // if (serviceId == 'PM') {
        //   const sort_arr = ['PKG', 'FRE', 'LGLFRENV', 'PFRENV', 'SFRB', 'FRB', 'LFRB', 'MLFRB', 'RBA', 'RBB', 'SOFTPACK']
        //   const new_rules = sort_arr.map(i => rules.find(r => r.parcelType === i))
        //   rules = new_rules
        // } else if (serviceId == 'PMI') {
        //   const sort_arr = ['PKG', 'FRE', 'LGLFRENV', 'PFRENV', 'SFRB', 'FRB', 'LFRB']
        //   const new_rules = sort_arr.map(i => rules.find(r => r.parcelType === i))
        //   rules = new_rules
        // }

        // if (country === "US") {
        //   console.log("SERVICE CODE", serviceId);
        //   console.log("PACKAGE TYPES", rules);
        // }
        return rules;
      } catch (e) {
        console.error(e);
      }
    },
  getSignatureCarrierRules: (state) =>
    (serviceId, parcelType = "PKG", country = "US", full = false) => {
      const ruleGroup = country in state.carrier_rules
        ? state.carrier_rules[country][serviceId] || null
        : null;

      if (!ruleGroup || !ruleGroup["parcelTypeRules"]) {
        return full ? { rules: [], trackable: true } : [];
      }

      const parcelRules = ruleGroup["parcelTypeRules"].find((rule) => {
        return rule.parcelType === parcelType;
      });

      if (
        !parcelRules || !("specialServiceRules" in parcelRules) ||
        !_.isArray(parcelRules["specialServiceRules"])
      ) {
        return full ? { rules: [], trackable: true } : [];
      }

      let signatureRules = parcelRules["specialServiceRules"].filter((rule) => {
        return ["Sig", "ADSIG", "ADSIGRD", "DelCon"].includes(
          rule.specialServiceId,
        );
      }).map((rule) => {
        if (i18n.te(`shipping_rules.signature.${rule.specialServiceId}`)) {
          rule.brandedName = i18n.t(
            `shipping_rules.signature.${rule.specialServiceId}`,
          );
          // rename signature brandnames
          // if (['ADSIG', 'Sig'].includes(rule.specialServiceId)) {
          //   rule.brandedName += ' Confirmation'
          // }

          if (serviceId === "EM" && rule.specialServiceId === "Sig") {
            rule.brandedName += " (included)";
          }
        }
        return rule;
      });

      if (
        signatureRules.length &&
        parcelRules["trackable"] !== "REQUIRES_TRACKABLE_SPECIAL_SERVICE"
      ) {
        let name = "Waive Signature Confirmation";

        signatureRules.unshift({
          specialServiceId: null,
          code: null,
          brandedName: name,
        });
      }

      // SORT
      const sort_arr = [null, "DelCon", "Sig", "ADSIG", "ADSIGRD"];
      // console.log("SIG RULES", signatureRules);
      const new_rules = sort_arr.map((i) => {
        return signatureRules.find((r) => {
          if (r.code === null && i === null) return true;
          else return r.specialServiceId === i;
        });
      });
      signatureRules = new_rules.filter((r) => !!r);
      // console.log("SIG RULES", signatureRules);

      if (!full) {
        return signatureRules || [];
      } else {
        return {
          rules: signatureRules,
          trackable: parcelRules.trackable,
        };
      }
    },

  getInsuranceCarrierRules: (state) =>
    (serviceId, parcelType = "PKG", country = "US") => {
      return [
        { brandedName: "Shipsurance", specialServiceId: "shipsurance" },
      ];

      // if (country === "US") {
      //   return [
      //     {
      //       brandedName: "PB Parcel Protection",
      //       specialServiceId: "parcel-protection",
      //     },
      //   ];
      // }

      // // USPS insurance options below
      // const ruleGroup = country in state.carrier_rules
      //   ? state.carrier_rules[country][serviceId] || null
      //   : null;

      // if (!ruleGroup || !ruleGroup["parcelTypeRules"]) {
      //   return [];
      // }

      // const parcelRules = ruleGroup["parcelTypeRules"].find((rule) => {
      //   return rule.parcelType === parcelType;
      // });

      // if (!_.isArray(parcelRules["specialServiceRules"])) {
      //   return [];
      // }

      // const signatureRules = parcelRules["specialServiceRules"].filter(
      //   (rule) => {
      //     return rule.specialServiceId === "Ins";
      //   },
      // );

      // return signatureRules || [];
    },

  getPackageTypes(state, getters) {
    return state.package_types;
  },

  getDefaultPrinter(state, getters) {
    return state.printer.default;
  },

  getLabelOrientation(state, getters) {
    if (_.isObject(state.user.shipping_label_format)) {
      const { orientation } = state.user.shipping_label_format;
      return orientation;
    } else {
      return null;
    }
  },

  getPrinterType(state, getters) {
    if (_.isObject(state.user.shipping_label_format)) {
      const { id } = state.user.shipping_label_format;
      if ([1, 2].includes(id)) return "raw";
      else return "pixel";
    } else {
      return "pixel";
    }
  },

  getLabelMargins(state, getters) {
    console.log("getLabelMargins");

    if (_.isObject(state.user.shipping_label_format)) {
      const { top, left, right, bottom } = state.user.shipping_label_format;
      return {
        top,
        left,
        right,
        bottom,
      };
    } else {
      return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
      };
    }
  },

  getLabelSize(state, getters) {
    try {
      if (_.isObject(state.user.shipping_label_format)) {
        const { width, height } = state.user.shipping_label_format;
        return {
          width,
          height,
        };
      } else {
        return { width: 8.5, height: 11 };
      }
    } catch (e) { }
  },

  getCustomsName(state, getters) {
    return state.customs_name;
  },

  getEmployeeName(state, getters) {
    if (state.employee_name) {
      // console.log("STORE GETEMPLOYEENAME", state.employee_name);
      return state.employee_name;
    }
    // console.log("LOCAL STORE GETEMPLOYEENAME", state.employee_name);
    return localStorage.getItem("shipper");
  },

  getEcommerceCount(state, getters) {
    return state.ecommerceCount;
  },

  getImportCount(state, getters) {
    return state.importCount;
  },

  recipients(state) {
    return state.recipients;
  },

  recipient: (state) =>
    (id) => {
      return state.recipients[id] || null;
    },

  products(state) {
    return state.products;
  },

  product: (state) =>
    (id) => {
      return state.products[id] || null;
    },

  serviceOptions: (state) =>
    (country = "US") => {
      // console.log("servcieoptions");
      // console.log("country", country);
      // console.log("state.carrier.country", state.carrier_rules[country]);
      if (state.carrier_rules[country]) {
        let options = Object.keys(state.carrier_rules[country]).map(
          (serviceId) => {
            return _.find(state.shipping_services, (s) => {
              return s.code === serviceId;
            });
          },
        );

        options = _.orderBy(options, "order");

        options = options.map((option) => {
          return {
            value: state.carrier_rules[country][option.code].service.id,
            text: option.name,
          };
        });
        // console.log("options", options);
        return options;
      }
    },
};

const plugins = [
  plugin,
  createPersistedState({
    paths: ["printer.default", "carrier_rules", "customs_name"],
  }),
];

const modules = { ws };
// console.log(modules);

// A Vuex instance is created by combining the state, mutations, actions, and
// getters.
export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  plugins,
  modules,
});



// WEBPACK FOOTER //
// ./resources/assets/js/store/index.js